import type { Signal } from '@angular/core';
import { computed } from '@angular/core';

let nextGroupId = 0;

/**
 * `<title>-<n>`: the filters render more than once per page (desktop column,
 * mobile sheet, map panel), so element ids and radio names need a suffix of
 * their own per instance.
 */
export function uniqueGroupName(
	title: string | Signal<string>,
): Signal<string> {
	const groupId = nextGroupId++;
	const read = typeof title === 'string' ? () => title : title;

	return computed(() => `${read()}-${groupId}`);
}
